<template>
  <div class="app-auth">
    <div class="app-auth__content">
      <h4>Reset Password</h4>
      <el-form ref="resetPasswordForm"
               :status-icon="true"
               :rules="validationRules"
               :model="formModel"
               label-position="right"
               @submit.native.prevent="submitForm('resetPasswordForm')">
        <el-form-item :label="$t('Password')" prop="password">
          <el-input v-model="formModel.password" type="password" />
        </el-form-item>
        <el-form-item :label="$t('Password Confirmation')" prop="password_confirmation">
          <el-input v-model="formModel.password_confirmation" type="password" />
        </el-form-item>
        <el-button :loading="isLoading"
                   type="primary"
                   native-type="submit">
          {{ $t('Submit') }}
        </el-button>
      </el-form>
      <div class="redirect-links">
        <router-link to="/login">
          {{ $t('Back to login') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import { resetPassword } from './api';

export default {
  name: 'ResetPassword',
  data() {
    return {
      validationRules: {
        password: [
          { required: true, message: this.$t('Please input password'), trigger: 'blur' },
          { min: 8, message: 'Should to be at least 8 characters', trigger: 'blur' }
        ],
        password_confirmation: [
          { min: 8, message: 'Should to be at least 8 characters', trigger: 'blur' },
          { required: true, message: this.$t('Please input password'), trigger: 'blur' }
        ]
      },
      formModel: {
        password: '',
        password_confirmation: ''
      },
      isLoading: false
    };
  },
  methods: {
    async sendForm() {
      const { formModel } = this;
      const { reset_password_token: token } = this.$route.query;
      this.isLoading = true;
      try {
        await resetPassword({ user: { ...formModel, reset_password_token: token } });
        Message({ type: 'info', message: 'Password has been reset.  Redirecting to login...' });
        setTimeout(() => {
          this.$router.push({ name: 'login' });
        }, 2000);
      } catch (error) {
        Message({ type: 'warning', message: 'Password has not been reset' });
        this.isLoading = false;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendForm();
        }
      });
    }
  }
};
</script>
